import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'reactstrap';
import classnames from 'classnames';
import './ripple-button.scss';

const RippleButton = ({className, children, onClick, ...rest}) => {
    const [isRippling, setIsRippling] = useState(false);
    const [coords, setCoords] = useState({x: -1, y: -1});

    useEffect(() => {
        let timeoutId;

        if (coords.x !== -1 && coords.y !== -1) {
            setIsRippling(true);
            timeoutId = setTimeout(() => setIsRippling(false), 500);
        }

        return () => clearTimeout(timeoutId);
    }, [coords]);

    const handleClick = (e) => {
        const rect = e.target.getBoundingClientRect();
        setCoords({x: e.clientX - rect.left, y: e.clientY - rect.top});
        onClick?.(e);
    };

    return (
        <Button
            className={classnames('waves-effect', className)}
            onClick={handleClick}
            {...rest}
        >
            {children}
            {isRippling && (
                <span
                    className="waves-ripple"
                    style={{left: coords.x, top: coords.y}}
                />
            )}
        </Button>
    );
};

RippleButton.propTypes = {
    ...Button.propTypes,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

Button.Ripple = RippleButton;
